import { render } from "./MessageCards.vue?vue&type=template&id=90a5f4c8"
import script from "./MessageCards.vue?vue&type=script&lang=js"
export * from "./MessageCards.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__